import type { InteriorTemplate, VenueKind, WorldManifest } from "@townsy/contracts";
import { getPlot } from "@townsy/world";
import { ARENA_CLIENTS, ARENA_TITLES } from "./arena";
import { casinoClient } from "./casino";
import { raceTrackClient } from "./raceTrack";
import { sportsCenterClient } from "./sportsCenter";
import { truckArenaClient } from "./truckArena";
import type { VenueClientModule } from "./types";

export const VENUE_CLIENTS: Record<VenueKind, VenueClientModule> = {
  casino: casinoClient,
  race_track: raceTrackClient,
  sports_center: sportsCenterClient,
  truck_arena: truckArenaClient,
  // Sports Park stadiums (ADR-0044).
  ...ARENA_CLIENTS,
};

export const VENUE_TITLES: Record<VenueKind, string> = {
  casino: "Townsy Casino",
  race_track: "Townsy Downs",
  sports_center: "Townsy Sports Center",
  truck_arena: "Monster Truck Arena",
  ...ARENA_TITLES,
};

/** The venue a property's room hosts (null for every other building). */
export function venueOf(manifest: WorldManifest, propertyId: string | null | undefined): VenueKind | null {
  if (!propertyId) return null;
  const plot = getPlot(manifest, propertyId);
  if (!plot) return null;
  const template: InteriorTemplate | undefined = manifest.interiors.find((t) => t.id === plot.interiorTemplate);
  return template?.venue ?? null;
}
